import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import queryString from 'query-string'
import Header from './components/Header'
import Nav from './components/Nav'
import Subscription from './tabs/subscription'
import Profile from './tabs/profile'
import Footer from './components/Footer'
import Spinner from './components/Spinner'
import CookieAccessor from './utils/cookieAccessor'
import StagingDebugBlock from './components/StagingDebugBlock'
import { createSession, setProfileData } from './actions/utils'
import { profileSelector } from './reducers/profile'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import './styles/app.scss'

/*global Rollbar*/
function App({ createSession, profile, setProfileData }) {
  dayjs.locale('ru')

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
    document.addEventListener('loginComplete', handleLoginComplete)
    return () => {
      document.removeEventListener('loginComplete', handleLoginComplete)
    }
  }, ['profile'])

  const mayHaveRadioOrKidsSubscription = profile && profile.activeSubscriptionTypes && profile.activeSubscriptionTypes.length
  const accountUUID = profile && profile.uuid
  useEffect(() => {
    if (mayHaveRadioOrKidsSubscription) {
      // TODO название may_have_radio_subscription не отражает сути, теперь исползуется и для подписок радио, и для гуся
      CookieAccessor.setCookie('may_have_radio_subscription', '1')
      CookieAccessor.setCookie('radio_account_uuid', accountUUID)
      if (typeof Rollbar !== "undefined") {
        Rollbar.configure({payload: {person: {id: accountUUID}, may_have_radio_subscription: true}});
      }
    } else {
      CookieAccessor.expireCookie('may_have_radio_subscription')
      CookieAccessor.expireCookie('radio_account_uuid')
      if (typeof Rollbar !== "undefined") {
        Rollbar.configure({payload: {person: null, may_have_radio_subscription: false}});
      }
    }
  }, [mayHaveRadioOrKidsSubscription, accountUUID])

  const fetchData = async () => {
    try {
      const sessionKey = process.env.REACT_APP_SESSION_KEY
      let localSession = CookieAccessor.getCookie(sessionKey)
      if (!localSession) {
        // если сессия записана в localstorage, переносим ее в куки
        localSession = window.localStorage.getItem(sessionKey)
        if (localSession) {
          CookieAccessor.setCookie(sessionKey, localSession)
          window.localStorage.removeItem(sessionKey)
        }
      }
      if (!Boolean(localSession)) {
        if (process.env.REACT_APP_PROMPT_FOR_SESSION_TOKEN === 'true') {
          const getSession = prompt(sessionKey, '')
          if (getSession !== null) {
            CookieAccessor.setCookie(sessionKey, getSession)
            await createSession(getSession)
          }
        }
      } else {
        await createSession(localSession)
        handleAuthResult()
      }
      setLoading(false)
    } catch (error) {
      console.log('[app] init error', error)
      setLoading(false)
    }
  }

  const handleLoginComplete = async event => {
    if (event.detail.globalSessionJwt) {
      await createSession(event.detail.globalSessionJwt, false)
    }
    const accountData = event.detail.accountDataResponse
    setProfileData(accountData)
  }

  const [appleFail, setAppleFail] = useState(null)
  const [vkFail, setVkFail] = useState(null)

  const handleAuthResult = async () => {
    const query = queryString.parse(window.location.search)
    if (query.auth_result === 'ok') {
      window.history.replaceState({}, null, `${window.location.origin}${window.location.pathname}`)
    } else if (query.auth_result === 'fail') {
      const defaultErrorMessage =
        'Что-то пошло не так. Пожалуйста, напишите нам на адрес <a href="mailto:radio@arzamas.academy">radio@arzamas.academy</a>, и мы разберемся'
      const errorMessage = query.error_message ? query.error_message : defaultErrorMessage
      if (query.auth_provider === 'apple') {
        setAppleFail(errorMessage)
      }
      if (query.auth_provider === 'vk') {
        setVkFail(errorMessage)
      }
      window.history.replaceState({}, null, `${window.location.origin}${window.location.pathname}`)
    }
  }

  return (
    <Router>
      <div className="account">
        {loading ? (
          <Spinner isScreen />
        ) : !profile ? null : (
          // <div className="account-global-error">
          //   <div>
          //     <div className="account-global-error__title">Что-то пошло не так</div>
          //     <p>
          //       Попробуйте войти в аккаунт через другой браузер.
          //       <br />
          //       Напишите нам на <a href="mailto:radio@arzamas.academy">radio@arzamas.academy</a>, мы поможем
          //       разобраться с данной проблемой!
          //     </p>
          //   </div>
          // </div>
          <>
            <Header />
            <Nav />
            <Switch>
              <Route exact path="/">
                <Redirect to="/account" />
              </Route>
              <Route exact path="/account">
                <Subscription />
              </Route>
              <Route exact path="/account/subscriptions">
                <Redirect to="/account" />
              </Route>
              <Route exact path="/account/edit">
                <Profile appleFail={appleFail} vkFail={vkFail} />
              </Route>
              <Route exact path="/account/debug">
                <StagingDebugBlock />
              </Route>
            </Switch>
            <Footer />
          </>
        )}
      </div>
    </Router>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector
})

export default connect(mapStateToProps, { createSession, setProfileData })(App)
